import React from 'react';
import { useForm } from 'react-hook-form';
import { PATIENT_SEARCH_COLUMNS } from './subparts/patientFilesQuery';

function PatientSearchForm2({
    onSearch,
    onShowAll,
    isLoading,
    searchTerm: externalSearchTerm,
    searchColumn: externalSearchColumn,
}) {
    const { register, handleSubmit, watch, setValue } = useForm({
        defaultValues: {
            searchTerm: externalSearchTerm || '',
            searchColumn: externalSearchColumn || 'firstName',
        },
    });

    const searchTerm = watch('searchTerm', '');
    const searchColumn = watch('searchColumn', 'firstName');

    const onSubmit = (data) => onSearch(data.searchColumn, data.searchTerm);

    const handleClear = () => {
        setValue('searchTerm', '');
        onSearch(searchColumn, '');
    };

    const handleColumnChange = (column) => {
        setValue('searchColumn', column);
        if (searchTerm.trim()) {
            onSearch(column, searchTerm);
        }
    };

    return (
        <div className="patient-files-filters">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="patient-files-filters__row">
                    <div className="patient-files-filters__search input-group input-group-sm">
                        <span className="input-group-text bg-white border-end-0">
                            <i className="bi bi-search text-muted" />
                        </span>
                        <input
                            type="text"
                            className="form-control form-control-sm border-start-0"
                            placeholder="Search patients by exact value..."
                            {...register('searchTerm')}
                            disabled={isLoading}
                        />
                        {searchTerm && (
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary ecx-modal__close-btn"
                                onClick={handleClear}
                                disabled={isLoading}
                                aria-label="Clear search"
                            >
                                <i className="bi bi-x-lg" />
                            </button>
                        )}
                        <button
                            type="submit"
                            className="btn btn-sm btn-light-primary"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-1" role="status" />
                                    Searching
                                </>
                            ) : (
                                <>
                                    <i className="bi bi-search me-1" />
                                    Search
                                </>
                            )}
                        </button>
                    </div>

                    <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={onShowAll}
                        disabled={isLoading}
                    >
                        <i className="bi bi-people me-1" />
                        Show All
                    </button>
                </div>

                <div className="patient-files-filters__row">
                    <div className="patient-files-filters__group">
                        <span className="patient-files-filters__label">Search By</span>
                        <div className="patient-files-pills">
                            {PATIENT_SEARCH_COLUMNS.map((option) => (
                                <label
                                    key={option.value}
                                    htmlFor={`patient-search-${option.value}`}
                                    className={`patient-files-pill mb-0 ${
                                        searchColumn === option.value ? 'is-active' : ''
                                    }`}
                                >
                                    <input
                                        type="radio"
                                        id={`patient-search-${option.value}`}
                                        className="visually-hidden"
                                        value={option.value}
                                        {...register('searchColumn')}
                                        onChange={(e) => handleColumnChange(e.target.value)}
                                    />
                                    <i className={`bi ${option.icon}`} />
                                    {option.label}
                                </label>
                            ))}
                        </div>
                    </div>

                    <p className="patient-files-filters__hint mb-0">
                        <i className="bi bi-info-circle" />
                        Partial match search is supported using RSQL wildcards.
                    </p>
                </div>
            </form>
        </div>
    );
}

export default PatientSearchForm2;
